import React from 'react';

export const SvgHereEn = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 1236 653'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='Here_en_svg__a'>
        <path d='M131 1494h1239v655H131z' />
      </clipPath>
    </defs>
    <g
      transform='matrix(.99793 0 0 .99758 -130.94 -1490.6)'
      clipPath='url(#Here_en_svg__a)'
    >
      <path
        d='M133.5 1604.8c0-59.84 48.503-108.34 108.34-108.34h1017.3c59.84 0 108.34 48.5 108.34 108.34v433.32c0 59.84-48.5 108.34-108.34 108.34H241.84c-59.832 0-108.34-48.5-108.34-108.34z'
        fillRule='evenodd'
        stroke='#4472c4'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
    </g>
    <g
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 292.86
      }}
      aria-label='HERE'
    >
      <path d='M397.62 422.4h-54.238v-92.657h-80.086V422.4h-54.238V212.09h54.238v76.979h80.086V212.09h54.238zM603.41 422.4H451.29V212.09h152.12v40.679h-98.165v36.3h91.103v40.679h-91.103v51.978h98.165zM766.83 276.49q0-7.91-3.249-13.56-3.248-5.65-11.158-8.898-5.508-2.26-12.853-2.684-7.344-.565-17.09-.565h-19.634v56.639h16.667q12.995 0 21.752-1.271 8.758-1.271 14.69-5.791 5.65-4.379 8.192-9.605 2.683-5.367 2.683-14.266zm84.606 145.91h-66.244l-57.346-77.12h-25v77.12H648.89V212.09h90.962q18.644 0 32.063 2.119 13.418 2.118 25.142 9.18 11.865 7.063 18.786 18.363 7.062 11.158 7.062 28.108 0 23.305-10.876 37.995-10.735 14.689-30.79 24.435zM1027.3 422.4H875.18V212.09h152.12v40.679h-98.165v36.3h91.103v40.679h-91.103v51.978h98.165z' />
    </g>
  </svg>
);
